import { Navigate } from "react-router";
import { screenNameConstants, viewPathConstants } from "../constants";
import Login from "../container/views/login/Login";
import ForgotPassword from "../container/views/forgotPassword/ForgotPassword";
import NewPassword from "../container/views/newPassword/NewPassword";
import Registeration from "../container/views/registeration/Registeration";
import EmailApproval from "../container/views/EmailApproval/EmailApproval";
import RegistrationSuccess from "../container/views/RegistrationSuccess/RegistrationSuccess";
import Leaderboard from "../modules/CustomerPortal/Views/Leaderboard/Leaderboard";
import Calendar from "../container/views/Calendar/Calendar";
import CenterRegistrationPage from "../container/views/CenterRegistration/CenterRegistrationPage";
import CenterPayment from "../container/views/CenterPayment/CenterPayment";
import DisabledInstructorModal from "../shared/components/Modals/DisabledInstructorModal";
import PublicSpot from "../container/views/Spots/PublicSpot";
import ViewCenters from "../modules/GuestUser/Views/Centers/ViewCenters";
import ViewCenterProfile from "../modules/GuestUser/Views/Centers/CenterProfile/ViewCenterProfile";
import InstructorDetail from "../shared/components/InstructorDetail";
import SpotDetail from "../container/views/Spots/SpotDetails/SpotDetail";
import PublicEvents from "../modules/GuestUser/Views/Events/PublicEvents";
import PublicEventDetailView from "../modules/GuestUser/Views/Events/Page/PublicEventDetailView";
import CompetitionsFeedback from "../container/views/Competitions/CompetitionFeedback/CompetitionFeedback";
import PublicCompetitions from "../modules/GuestUser/Views/Competitions/PublicCompetitions";
import DetailCompetition from "../modules/GuestUser/Views/Competitions/Page/DetailCompetition";
import CompetitionLeaderboard from "../modules/GuestUser/Views/Competitions/Page/CompetitionLeaderboard";
import FreelanceRePayment from "../container/views/FreelanceRePayment/FreelanceRePayment";

const routes = [
  // public routes
  {
    path: viewPathConstants.DEFAULT_PATH,
    name: screenNameConstants.LOGIN,
    component: <Login />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.UNKNOWN_PATH,
    name: screenNameConstants.LOGIN,
    component: <Navigate to={viewPathConstants.LOGIN} />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.LOGIN,
    name: screenNameConstants.LOGIN,
    component: <Navigate to={viewPathConstants.DEFAULT_PATH} />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.REGISTRATION,
    name: screenNameConstants.REGISTRATION,
    component: <Registeration />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.CENTER_REGISTRATION,
    name: screenNameConstants.CENTER_REGISTRATION,
    component: <CenterRegistrationPage />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.FORGOT_PASSWORD,
    name: screenNameConstants.FORGOT_PASSWORD,
    component: <ForgotPassword />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.RESET_PASSWORD,
    name: screenNameConstants.RESET_PASSWORD,
    component: <NewPassword />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.VERIFY_EMAIL,
    name: screenNameConstants.VERIFY_EMAIL,
    component: <EmailApproval />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.EMAIL_APPROVAL,
    name: screenNameConstants.EMAIL_APPROVAL,
    component: <EmailApproval />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.REGISTRATION_SUCCESS,
    name: "registrationsuccess",
    component: <RegistrationSuccess />,
    protected: false,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.COMPETITIONFEEDBACK,
    name: screenNameConstants.EVENTSFEEDBACK,
    component: <CompetitionsFeedback />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.CALENDAR,
    name: screenNameConstants.CALENDAR,
    component: <Calendar />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.VIEW_EVENTS,
    name: screenNameConstants.VIEW_EVENTS,
    component: <PublicEvents />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.VIEW_EVENT_DETAIL,
    name: screenNameConstants.VIEW_EVENT_DETAIL,
    component: <PublicEventDetailView />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.LEADERBOARD,
    name: "leaderboard",
    component: <Leaderboard />,
    protected: false,
    hasSideBar: false,
    hasSponserSideBar: true, // added for sponser side bar
    updateProtected: true,
  },
  {
    path: viewPathConstants.NOTIFICATION,
    name: "notification",
    component: <EmailApproval />,
    protected: true,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.CENTER_PENDING_PAYMENT,
    name: screenNameConstants.CENTER_PENDING_PAYMENT,
    component: <CenterPayment />,
    protected: true,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.FREELANCE_PENDING_PAYMENT,
    name: screenNameConstants.FREELANCE_PENDING_PAYMENT,
    component: <FreelanceRePayment />,
    protected: true,
    hasSideBar: false,
  },
  {
    path: viewPathConstants.DISABLED_INSTRUCTOR,
    name: "disabled-instructor",
    component: <DisabledInstructorModal />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.VIEW_ALL_SPOTS,
    name: screenNameConstants.SPOTS,
    component: <PublicSpot />,
    protected: false,
    hasSideBar: true,
    updateProtected: true,
  },
  {
    path: viewPathConstants.COMPETITION_LEADERBOARD,
    name: screenNameConstants.COMPETITIONS_LEADERBOARD,
    component: <CompetitionLeaderboard />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.PUBLIC_COMPETITIONS,
    name: screenNameConstants.COMPETITIONS,
    component: <PublicCompetitions />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.PUBLIC_COMPETITIONS_DETAIL,
    name: screenNameConstants.COMPETITIONS,
    component: <DetailCompetition />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.VIEW_CENTERS,
    name: screenNameConstants.CENTERS,
    component: <ViewCenters />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  // {
  //   path: viewPathConstants.MY_COMPETITIONS_DETAIL,
  //   name: screenNameConstants.MY_COMPETITIONS,
  //   component: <MyCompetitionDetail />,
  //   protected: true,
  //   hasSideBar: true,
  // },
  {
    path: viewPathConstants.VIEW_CENTER_PROFILE,
    component: <ViewCenterProfile />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.VIEW_INSTRUCTOR_PROFILE,
    component: <InstructorDetail />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
  {
    path: viewPathConstants.VIEW_SPOT_DETAIL,
    component: <SpotDetail />,
    protected: false,
    hasSideBar: false,
    updateProtected: true,
  },
];

export default routes;
